module.exports = __webpack_public_path__ + "static/media/ok.5aaa2a3a.png";